import React from 'react';

import theme from '@adsk/alloy-react-theme';

export const shouldIgnoreClickOutside = (e: any) => {
  let target = e.target;
  while (!(target.dataset && target.dataset.ignoreClickOutside)) {
    if (target === e.currentTarget || !target.parentNode) return false;
    target = target.parentNode;
  }
  return true;
};

export const useClickOutSide = (
  handler: (event: MouseEvent) => void,
  refs: {
    current?: HTMLElement | null;
  }[] = [],
  enabled = true
) => {
  React.useEffect(() => {
    if (!enabled) return;

    const listener = (e: any) => {
      const refsArr = Array.isArray(refs) ? refs : [refs];
      // Do nothing if
      // 1. target element has the data-ignore-click-outside attribute
      // 2. clicking tooltipRef’s element or descendent elements
      if (shouldIgnoreClickOutside(e) || refsArr.some((ref) => ref?.current?.contains(e.target))) {
        return;
      }
      handler(e);
    };

    document.addEventListener('mousedown', listener);

    // eslint-disable-next-line consistent-return
    return () => {
      document.removeEventListener('mousedown', listener);
    };
  }, [handler, refs, enabled]);
};

export const getArrowColor = (variant: string) => {
  switch (variant) {
    case 'light':
      return theme.tokens.colors.background.primary.value;
    case 'dark':
      return theme.tokens.colors.background.inverse.subtle.value;
    case 'medium':
      return theme.tokens.colors.background.inverse.selected.value;
    default:
      return theme.tokens.colors.background.primary.value;
  }
};

export const clearTimer = (timer: ReturnType<typeof setTimeout> | undefined): void => {
  if (timer) {
    clearTimeout(timer);
    timer = undefined;
  }
};
